import { IndexApplication } from './pages/index.app';
import { bootstrap } from './framework/bootstrap.fn';

bootstrap(IndexApplication);
